module.exports = __webpack_public_path__ + "img/monitor-02.679d4608.svg";